module.exports = __webpack_public_path__ + "1971b1ee2c217e9f8384c120cd7360c0.jpg";